import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("atr_logged_in") === "1") {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setError("");

    if (!username.trim() || !password.trim()) {
      setError("请输入用户名和密码");
      return;
    }

    localStorage.setItem("atr_logged_in", "1");
    localStorage.setItem("atr_user", username.trim());
    navigate("/", { replace: true });
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background-50 px-6 py-12">
      <div className="w-full max-w-md">
        <h1 className="text-center text-2xl font-semibold leading-relaxed text-foreground-950">
          基于大数据的多维度文章智能打标
        </h1>
        <p className="mt-2 text-center text-sm text-foreground-500">
          请输入账号信息以进入打标工作台
        </p>

        <form onSubmit={handleSubmit} className="mt-8">
          <label className="mb-1.5 block text-sm font-medium text-foreground-800" htmlFor="username">
            用户名
          </label>
          <div className="mb-4 flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100">
            <i className="ri-user-line text-base text-foreground-400" />
            <input
              id="username"
              name="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="请输入用户名"
              className="h-11 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>

          <label className="mb-1.5 block text-sm font-medium text-foreground-800" htmlFor="password">
            密码
          </label>
          <div className="mb-4 flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100">
            <i className="ri-lock-line text-base text-foreground-400" />
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="请输入密码"
              className="h-11 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>

          {error ? (
            <div role="alert" className="mb-4 flex items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-3 py-2.5 text-sm text-primary-700">
              <i className="ri-error-warning-line" />
              {error}
            </div>
          ) : null}

          <button
            type="submit"
            className="h-11 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
          >
            登录
          </button>
        </form>
      </div>
    </div>
  );
}
